import { useState, useEffect } from "react";
import { usePage } from "@inertiajs/react";

import TextField from "/components/TextField";

export default function SettingTextField({
  name,
  value: defaultValue,
  delay = 1000,
}) {
  const props = usePage().props;

  const [value, setValue] = useState(defaultValue);
  const [checkValue, setCheckValue] = useState(value);
  const [inProgress, setInProgress] = useState(false);

  const onChange = (newValue) => {
    if (newValue == checkValue || newValue.length < 1)
      return;

    setCheckValue(newValue);

    setInProgress(true);
    fetch(`/admin/settings/${name}`,{
      method: "PUT",
      body: JSON.stringify({ authenticity_token: props.csrf_token, value: newValue }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      setCheckValue(newValue);
      setInProgress(false);
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, onChange, delay]);

  return (
    <TextField onChange={(newValue) => setValue(newValue)} value={value} disabled={inProgress} />
  );
}
